import { render, staticRenderFns } from "./InvenstmentManage.vue?vue&type=template&id=3b75e2ce&"
import script from "./InvenstmentManage.vue?vue&type=script&lang=js&"
export * from "./InvenstmentManage.vue?vue&type=script&lang=js&"
import style0 from "./InvenstmentManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports